import Modal from '../../../components/modal'

export default function VinInstruction({ onClose }) {
  return (
    <Modal onClose={onClose}>
      <div className='wrapper flex flexDirectionColumn alignCenter'>
        <p>You can find your VIN in 2 places:</p>
        <img src='/images/find-vin.png' alt='car skeleton' width='604' height='391' />
        <p className='instructions'>
          Driver's side, lower corner of the windshield <br />
          Driver's side, lower portion of the inner door frame
        </p>
      </div>

      <style jsx>{`
        .wrapper {
          position: relative;
          padding: 2rem 1.2rem;
          border-radius: 1rem;
          background: var(--primary-bg-color);

          p {
            text-align: center;
            font-size: 1.6rem;

            &.instructions {
              position: absolute;
              bottom: 2rem;
            }
          }

          img {
            max-width: 100%;
            min-width: 60.4rem;
            height: auto;
          }
        }

        @media (max-width: 1024px) {
          .wrapper {
            p {
              font-size: 1.4rem;

              &.instructions {
                bottom: 0;
              }
            }

            img {
              min-width: unset;
            }
          }
        }
      `}</style>
    </Modal>
  )
}
